import ThemeToggle from '../theme_toggle';
import { Drafts } from '../calligraff/editor/drafts.js';

new ThemeToggle();
Drafts.clearOtherUsers(document.body?.dataset.currentUser || '').catch(() => {});

document.addEventListener('change', (event) => {
  const select = event.target.closest?.('[data-language-select]');
  if (select) window.location.assign(select.value);
});
